import { useMemo } from "react";

const START_HOUR = 8;
const END_HOUR = 21;
const SLOT_HEIGHT = 30;

const useDayCalendar = () => {
  const timeSlots = useMemo(() => {
    const slots = [];
    slots.push(``);
    for (let h = START_HOUR; h < END_HOUR; h++) {
      slots.push(`${String(h).padStart(2, "0")}:00`);
      slots.push(`${String(h).padStart(2, "0")}:10`);

      slots.push(`${String(h).padStart(2, "0")}:20`);
      slots.push(`${String(h).padStart(2, "0")}:30`);
      slots.push(`${String(h).padStart(2, "0")}:40`);
      slots.push(`${String(h).padStart(2, "0")}:50`);
    }
    return slots;
  }, []);

  const getTop = (time) => {
    const [hour, minute] = time.split(":").map(Number);

    return ((hour - START_HOUR) * 6 + minute / 10) * SLOT_HEIGHT + SLOT_HEIGHT;
  };

  const getHeight = (start, end) => {
    const [sh, sm] = start.split(":").map(Number);

    const [eh, em] = end.split(":").map(Number);

    const duration = eh * 60 + em - (sh * 60 + sm);

    return (duration / 10) * SLOT_HEIGHT - 1;
  };

  const isToday = (date) => {
    const today = new Date();

    return date.toDateString() === today.toDateString();
  };

  return {
    timeSlots,
    getTop,
    getHeight,
    isToday,
  };
};

export default useDayCalendar;
